export const basenames = {
    admin: '/admin',
    form: '/form',
    point: '/point',
    achievement: '/achievement',
    promotions: '/promotions',
    ugc: '/ugc'
};

export const appBaseName = (() => {
    const [, firstPathName] = window.location.pathname.split('/');
    const baseName = basenames[firstPathName] ?? basenames.promotions;
    return baseName;
})();
